import { LoadingButton as MuiLoadingButton } from "@mui/lab";
import { styled } from "@mui/material/styles";
import LanguageIcon from "@mui/icons-material/Language";

const LoadingButton = ({ id, isLoading, text, onClick }) => {
  const Styled = styled(MuiLoadingButton)(({ theme }) => ({
    border: "none",
    borderRadius: 0,
    whiteSpace: "nowrap",
    fontSize: "22px",
    fontFamily: "Noto Sans KR",
    fontWeight: "bold",
    backgroundColor: "#fff",
    color: "#000",
    textTransform: "none",
    display: "flex",
    gap: "10px",
  }));

  return (
    <Styled id={id} loading={isLoading} onClick={onClick}>
      <LanguageIcon fontSize="large" />
      {text}
    </Styled>
  );
};

export default LoadingButton;
